import _ from 'underscore';
import { BaseAccountsSchemaProcessor } from './base-accounts-schema-processor';
import { initialize as initializeAvailableInsightTypeIds, updateEntitySchemaForAvailableInsightTypeIds, updateOdataOptionsForAvailableInsightTypeIds } from '../util/update-available-insight-type-ids-property-for-filter';

export class PerformanceSchemaProcessor extends BaseAccountsSchemaProcessor {
  constructor(options) {
    const propWhitelist = _.compact([
      'Name',
      'Currency',
      'AccountType',
      'Owner',
      'BillToCustomerName',
      'Budget/DailyBudget',
      'InsertionOrderDetails/CurrentInsertionOrder/Budget',
      'InsertionOrderDetails/CurrentInsertionOrder/RemainingBudget',
      'InsertionOrderDetails/CurrentInsertionOrder/StartDate',
      'InsertionOrderDetails/CurrentInsertionOrder/EndDate',
      'InsertionOrderDetails/CurrentInsertionOrder/PurchaseOrder',
      'AvailableInsightTypeIds',
    ]);

    initializeAvailableInsightTypeIds(options);
    super(options, { propWhitelist, allowBiPattern: true });
  }

  getOverridenSchemaProperties() {
    return {
      // TODO: Task 2242006 Date selection filter
      InsertionOrderDetailsCurrentInsertionOrderEndDate: { filterable: false },
      // TODO: Task 2242006 Date selection filter
      InsertionOrderDetailsCurrentInsertionOrderStartDate: { filterable: false },
    };
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);
    updateEntitySchemaForAvailableInsightTypeIds(updatedSchema);
    updatedSchema.properties = _.omit(
      updatedSchema.properties,
      'PerformanceMetricsCostPerInstall',
      'PerformanceMetricsRevenuePerInstall'
    );
    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForAvailableInsightTypeIds(odataOptions);
    return odataOptions;
  }
}
